import React from 'react';
import ThemeToggle from '../components/Succession/ThemeToggle';

/**
 * Container component for ThemeToggle that provides the necessary React context
 * for ReactOnRails rendering. This wrapper ensures hooks can be called properly.
 */
const ThemeToggleContainer = (props) => {
  return <ThemeToggle {...props} />;
};

export default ThemeToggleContainer; 